module.exports = __webpack_public_path__ + "img/loading-spinner.719464cf.gif";